import { SubjectPermissionPage } from './SubjectPermissionPage';
export default SubjectPermissionPage;
